export var CollaboratorRole;
(function (CollaboratorRole) {
    CollaboratorRole[CollaboratorRole["Collaborator"] = 0] = "Collaborator";
    CollaboratorRole[CollaboratorRole["TransportManager"] = 1] = "TransportManager";
})(CollaboratorRole || (CollaboratorRole = {}));
